import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns a string in HH:MM:SS format.
 * 
 * @input hours 
 * @input minutes
 * @input seconds 
 * 
 * 
 */
@Pipe({
    name: 'timeHhMmSs',
    standalone: false
})
export class TimeHhMmSsPipe implements PipeTransform {
	transform(hoursNbr: number, minutesNbr: number, secondsNbr: number) {
        return this.transformString(hoursNbr.toString(), minutesNbr.toString(), secondsNbr.toString());
	}
    
    transformString(hours: string, minutes: string, seconds: string) {
        hours = hours == undefined || hours.length == 0 ? '00' : hours.length == 1 ? '0'+hours : hours;
        minutes = minutes == undefined  || minutes.length == 0 ? '00' : minutes.length == 1 ? '0'+minutes : minutes;
        seconds = seconds == undefined  || seconds.length == 0 ? '00' : seconds.length == 1 ? '0'+seconds : seconds;
        
        return hours+':'+minutes+':'+seconds;
    }

}